import { Pipe, PipeTransform } from '@angular/core';
import { DefaultIconSize, IconSize } from './icon-size.enum';

const SIZE_CLASS_MAP: Record<string, string> = {
  [IconSize.ExtraSmall]: 'cux-icon--extra-small',
  [IconSize.Small]: 'cux-icon--small',
  [IconSize.Medium]: 'cux-icon--medium',
  [IconSize.Large]: 'cux-icon--large',
  [IconSize.ExtraLarge]: 'cux-icon--extra-large',
};

@Pipe({ name: 'iconSize' })
export class IconSizePipe implements PipeTransform {
  transform(value: IconSize): string {
    return SIZE_CLASS_MAP[value ?? DefaultIconSize] ?? '';
  }
}
